<template>
  <ul>
    <li v-for="(item, index) in list" :key="index">
      <a :href="item.href" :aria-label="'Get more information about ' + item.title">{{ item.title }}</a>
      <span v-if="item.description">: {{ item.description }}</span>
    </li>
  </ul>
</template>

<script setup lang="ts">
import { computed } from 'vue';
import { LinksList } from '@bifrost-dev-docs-mfe/common/types/linksList';

const props = defineProps({ encodedData: { type: String, required: true } });
const list = computed(() =>
  (JSON.parse(decodeURIComponent(props.encodedData)) as LinksList).filter(item => !item.ignoreInList)
);
</script>
